import clsx from "clsx";
import { Icons, Tooltip, Box } from "@curves/ui-base";
import React from "react";
import { isEqual, isFunction } from "@util/utils";

const EditableInfo = ({ className, onEdit, label, children, isMultiline }) => {
	const isEdit = isFunction(onEdit);

	const handleClick = () => {
		isEdit && onEdit();
	};

	return (
		<Box
			className={clsx("editable-info", isMultiline && "editable-info--multiline", isEdit && "editable-info--edit", className)}
			onClick={handleClick}>
			<Box className="editable-info__title">{label}</Box>
			{isEqual(children, "string") ? (
				<Tooltip title={children}>
					<Box className="editable-info__content">{children}</Box>
				</Tooltip>
			) : (
				<Box className="editable-info__content">{children}</Box>
			)}
			{isEdit && <Icons.Edit className={"editable-info__icon"} />}
		</Box>
	);
};

export default EditableInfo;
